export const STORE_MARKER = Symbol("STORE_MARKER");
export const STORE_GET = Symbol("STORE_GET");
export const STORE_UNGET = Symbol("STORE_UNGET");
export const STORE_GETACTIONS = Symbol("STORE_GETACTIONS");
export const ACTION_MARKER = Symbol("ACTION_MARKER");
